import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

export interface Perfil {
  auth_key: string;
  data: [
    {
      id: number;
      id_user: number;
      nombre: string;
      nikname: string;
      id_instituto: number;
      instituto: string;
      fecha_nac: string;
      idiomas: string;
      intereses: string;
      sobre_mi: string;
      identificacion: number;
    }
  ];
}

export interface ContactoPerfil {
  auth_key: string;
  data: [
    {
      direccion: string;
      direccionV: number;
      telefono: string;
      telefonoV: number;
      correo: string;
      correoV: number;
    }
  ];
}
@Injectable({
  providedIn: "root",
})
export class PerfilService {
  varBorrar: any;
  constructor(private http: HttpClient) {}

  get(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    return this.http.post<Perfil>(
      environment.urlPerfil + "?opcion=1",
      formData
    );
  }

  getContactoPerfil(id, auth_key) {
    console.log("get informacion contacto");
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    return this.http.post<Perfil>(
      environment.urlPerfil + "?opcion=1",
      formData
    );
    // return this.varBorrar;
  }
  getPerfilByIds(id, auth_key, ids) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("ids", ids);
    return this.http.post<Perfil>(
      environment.urlPerfil + "?opcion=3",
      formData
    );
    /********************** */
  }
  getPerfilByIdCurso(id, auth_key, id_curso) {
    console.log("id");
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("id_curso", id_curso);
    return this.http.post<Perfil>(
      environment.urlPerfil + "?opcion=5",
      formData
    );
    /********************** */
  }
  getSobreMi(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    return this.http.post(environment.urlPerfil + "?opcion=4", formData);
    /********************** */
  }
  createSobreMi(id, auth_key, texto) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("SobreMi[id_user]", id);
    formData.append("SobreMi[texto]", texto);
    return this.http.post(environment.urlPerfil + "?opcion=4", formData);
    /********************** */
  }

  create(id, auth_key, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];

    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("Usuario[nombre_apellido]", data.nombre);
    formData.append("PerfilDatos[nikname]", "@" + data.nickname);
    if (data.institutoId) {
      formData.append("PerfilDatos[id_instituto]", data.institutoId);
    }
    if (data.instituto.nombre) {
      formData.append("Institutos[nombre]", data.instituto.nombre);
    }
    formData.append("PerfilDatos[fecha_nac]", data.fechanac);
    formData.append("PerfilDatos[idiomas]", data.idiomas);
    formData.append("PerfilDatos[intereses]", data.intereses);
    formData.append("PerfilDatos[sobre_mi]", data.sobremi);
    formData.append("PerfilDatos[noidentificacion]", data.identificacion);
    formData.append("PerfilDatos[noidentificacion]", data.identificacion);
    formData.append("PerfilDatos[direccion]", data.direccion);
    formData.append("PerfilDatos[telefono]", data.telefono);
    formData.append("PerfilDatos[fecha_nac_visible]", data.fecha_nac_visible);
    formData.append(
      "PerfilDatos[id_instituto_visible]",
      data.id_instituto_visible
    );
    formData.append("PerfilDatos[idiomas_visible]", data.idiomas_visible);
    formData.append("PerfilDatos[intereses_visible]", data.intereses_visible);
    formData.append("PerfilDatos[nikname_visible]", data.nikname_visible);
    formData.append(
      "PerfilDatos[noidentificacion_visible]",
      data.noidentificacion_visible
    );
    formData.append("PerfilDatos[sobre_mi_visible]", data.sobre_mi_visible);
    if (data.otro) {
      formData.append("otro", data.otro);
    }
    data.redes.forEach((element, index: number) => {
      formData.append("PerfilRedes[" + index + "][sitio_web]", element.url);
      formData.append(
        "PerfilRedes[" + index + "][sitio_web_visible]",
        element.visible
      );
      formData.append("PerfilRedes[" + index + "][id]", element.id);
    });
    return this.http.post<any>(environment.urlPerfil + "?opcion=2", formData);
  }

  updatePerfil(id, auth_key, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];

    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("Usuario[nombre_apellido]", data.nombre);
    formData.append("PerfilDatos[nikname]", "@" + data.nickname);
    return this.http.post<any>(environment.urlPerfil + "?opcion=2", formData);
  }

  createInfoContacto(id, auth_key, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];

    let formData = new FormData();
    formData.append("id_user", id);
    formData.append("auth_key", auth_key);
    formData.append("InformacionContacto[telefono]", data.nombre);
    formData.append("InformacionContacto[direccion]", data.nickname);
    formData.append("InformacionContacto[correo]", data.institutoId);
    formData.append("InformacionContacto[visible_telefono]", data.instituto);
    formData.append("InformacionContacto[visible_direccion]", data.fechanac);
    formData.append("InformacionContacto[visible_correo]", data.idiomas);

    this.http.post<any>(environment.urlPerfil + "?opcion=2", formData);
    return this.varBorrar;
    /********************** */
  }

  updateState(id, auth_key, state) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("PerfilDatos[estado]", state);
    return this.http.post<any>(environment.urlPerfil + "?opcion=6", formData);
  }

  changePassword(id, auth_key, curent_pasword, new_password) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("User[password]", curent_pasword);
    formData.append("new_password", new_password);
    return this.http.post<any>(environment.urlPerfil + "?opcion=7", formData);
  }

  getFollow(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    return this.http.post(environment.urlPerfil + "?opcion=8", formData);
    /********************** */
  }

  getLanguaje(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    return this.http.get(environment.urlLogin);
  }

  getPupilosTutores(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    return this.http.post(environment.urlPerfil + "?opcion=13", formData);
    /********************** */
  }

  createPupiloTutor(id, auth_key, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    formData.append("PupiloTutor[id_pupilo]", data.id_pupilo);
    formData.append("PupiloTutor[id_tutor]", data.id_tutor);
    formData.append("PupiloTutor[id_aprueba]", data.id_aprueba);
    return this.http.post<any>(environment.urlPerfil + "?opcion=10", formData);
  }

  deletePupiloTutor(id, auth_key, id_solicitud) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    formData.append("id_solicitud", id_solicitud);
    return this.http.post<any>(environment.urlPerfil + "?opcion=14", formData);
  }

  aprovePupiloTutor(id, auth_key, id_solicitud) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    formData.append("id_solicitud", id_solicitud);
    return this.http.post<any>(environment.urlPerfil + "?opcion=11", formData);
  }

  rejectPupiloTutor(id, auth_key, id_solicitud) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    formData.append("id_solicitud", id_solicitud);
    return this.http.post<any>(environment.urlPerfil + "?opcion=12", formData);
  }

  getNotificaciones(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    return this.http.post(environment.urlPerfil + "?opcion=20", formData);
    /********************** */
  }

  updateNotificaciones(id, auth_key, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("Notificaciones[mis_eventos]", data.mis_eventos);
    formData.append("Notificaciones[eventos_pupilos]", data.eventos_pupilos);
    formData.append("Notificaciones[cursos_aprendo]", data.cursos_aprendo);
    formData.append("Notificaciones[cursos_enseno]", data.cursos_enseno);
    return this.http.post<any>(environment.urlPerfil + "?opcion=19", formData);
  }

  desactiveAcount(id, auth_key,data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let formData = new FormData();
    formData.append("id", id);
    formData.append("auth_key", auth_key);
    formData.append("username", data.correo);
    formData.append("password", data.contrasena);
    return this.http.post(environment.urlPerfil + "?opcion=24", formData);
    /********************** */
  }
}
